export enum SplitScreenVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3A = 'v3A',
  V3B = 'v3B',
}